import { tv } from '@change/ds-utils';

export const TextSkeletonContainerStyles = tv({
	base: 'flex flex-col',
	variants: {
		size: {
			xsmall: 'gap-0.5',
			small: 'gap-0.5',
			medium: 'gap-[3px]',
			large: 'gap-1',
		},
	},
});

export const TextSkeleton1Styles = tv({
	base: '',
	variants: {
		size: {
			xsmall: 'w-[50px]',
			small: 'w-[65px]',
			medium: 'w-[143px]',
			large: 'w-[160px]',
		},
	},
});

export const TextSkeleton2Styles = tv({
	base: '',
	variants: {
		size: {
			xsmall: 'w-[36px]',
			small: 'w-[36px]',
			medium: 'w-[80px]',
			large: 'w-[90px]',
		},
	},
});
